export default __webpack_public_path__ + "static/media/wildfire_prediction_reduced.b61d4a36.gif";